import DiscourseRoute from "discourse/routes/discourse";
import { ajax } from "discourse/lib/ajax";

export default class ProxyviewsVendorDashboardRoute extends DiscourseRoute {
  async model(params) {
    try {
      const response = await ajax(`/vendor/proxyviews-directory/providers/${params.slug}`);
      return response.provider || response;
    } catch (e) {
      if (e.jqXHR && e.jqXHR.status === 403) {
        this.router.transitionTo("proxyviews-directory");
      }
      throw e;
    }
  }

  setupController(controller, model) {
    super.setupController(...arguments);
    controller.setProperties({
      provider: model,
      editingPricing: JSON.stringify(model.pricing_tiers || {}, null, 2),
      editingDescription: model.description || "",
      isSaving: false,
    });
  }
}
